import packageMetadata from "../../package.json";

export const RELEASE_VERSION = packageMetadata.version;
export const HISTORICAL_EVIDENCE_VERSION = "1.0.0";
export const HISTORICAL_EVIDENCE_URL =
  "https://uceevidencelens.com/evidence/v1.0.0";
